exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-plasmic-host-jsx": () => import("./../../../src/pages/plasmic-host.jsx" /* webpackChunkName: "component---src-pages-plasmic-host-jsx" */),
  "component---src-templates-default-plasmic-page-jsx": () => import("./../../../src/templates/defaultPlasmicPage.jsx" /* webpackChunkName: "component---src-templates-default-plasmic-page-jsx" */)
}

